const AUTH_HINT_COOKIE_NAME = 'jeeum_auth_hint';
const AUTH_HINT_MAX_AGE_SECONDS = 7 * 24 * 60 * 60;

export function hasAuthCookie(): boolean {
  if (typeof document === 'undefined') {
    return true;
  }

  return document.cookie
    .split(';')
    .some((part) => part.trim().startsWith(`${AUTH_HINT_COOKIE_NAME}=1`));
}

export function setAuthCookieHint(): void {
  if (typeof document === 'undefined') {
    return;
  }

  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:'
    ? '; Secure'
    : '';
  const attributes = [
    `${AUTH_HINT_COOKIE_NAME}=1`,
    'path=/',
    `Max-Age=${AUTH_HINT_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
  ];
  document.cookie = `${attributes.join('; ')}${secure}`;
}

export function clearAuthCookieHint(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${AUTH_HINT_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}
